import React from 'react';
import DefaultPageWithBreadcrumbs from 'src/backoffice-app-code/components/page/DefaultPageWithBreadcrumbs';
import { RetailersRoutes } from 'src/backoffice-app-code/routes/Routes';

import { useFetchAllRetailers } from '../../application/queries/useFetchAllRetailers';
import RedirectButtonWithCreateIcon from 'src/backoffice-app-code/components/buttons/RedirectButtonWithCreateIcon';
import { RetailersTableContainer } from './components/RetailersTableContainer';

const RetailersPage: React.FC = () => {
  const { data: retailers, isLoading, errorMessage } = useFetchAllRetailers();
  return (
    <DefaultPageWithBreadcrumbs
      title="Retaileri"
      links={[
        {
          name: 'Retaileri',
        },
      ]}
      breadcrumbsAction={
        <RedirectButtonWithCreateIcon label="Napravi retailera" route={RetailersRoutes.create} />
      }
    >
      <RetailersTableContainer
        retailers={retailers}
        isLoading={isLoading}
        errorMessage={errorMessage}
      />
    </DefaultPageWithBreadcrumbs>
  );
};

export default RetailersPage;
